import React, { useState, useEffect } from 'react';
import FacebookPagePlugin from '../facebook/FacebookPlugin';
import FacebookFeedFallback from '../FacebookFeedFallback';

const FacebookFeed = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile devices
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const checkMobile = () => setIsMobile(window.innerWidth <= 768);
      window.addEventListener('resize', checkMobile);
      checkMobile();
      return () => window.removeEventListener('resize', checkMobile);
    }
  }, []);

  const handleLoad = () => {
    setIsLoading(false);
    setHasError(false);
  };

  const handleError = (error: any) => {
    console.error('Facebook feed error:', error);
    setIsLoading(false);
    setHasError(true);
  };

  // Show fallback on mobile if there's an error
  if (isMobile || hasError) {
    return <FacebookFeedFallback />;
  }

  // Use different container classes based on device type
  const containerClasses = isMobile
    ? 'relative w-full facebook-feed-mobile'
    : 'relative h-full w-full pb-[150%] md:pb-[100%]';

  return (
    <div className={containerClasses}>
      {isLoading && (
        <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center bg-gray-100">
          <div className="text-center">
            <div className="mb-2 h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-primary"></div>
            <span className="text-sm text-gray-600">
              Loading Facebook feed...
            </span>
          </div>
        </div>
      )}
      {hasError && !isMobile && (
        <div className="absolute left-0 top-0 flex h-full w-full items-center justify-center bg-gray-100 p-4 text-center">
          <div>
            <p className="mb-2 text-gray-600">
              The Facebook feed is currently unavailable. Please visit our
            </p>
            <a
              href="https://www.facebook.com/mbautocaregarage"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-primary hover:underline"
            >
              Facebook page
            </a>{' '}
            for updates.
          </div>
        </div>
      )}
      <div
        className={`absolute left-0 top-0 h-full w-full ${
          isLoading || hasError ? 'opacity-0' : 'opacity-100'
        } facebook-feed-container`}
        style={{
          maxWidth: '100%',
          overflow: 'hidden',
          minHeight: isMobile ? '450px' : 'auto',
          height: isMobile ? '70vh' : '100%',
        }}
      >
        <FacebookPagePlugin onLoad={handleLoad} onError={handleError} />
      </div>
    </div>
  );
};

export default FacebookFeed;
